module.exports = __webpack_public_path__ + "img/002.b28f41a9.png";